import { apiRequest } from '@/lib/api-client';
import { getStoredAuthToken } from '@/lib/auth-storage';

export type CategoriaApi = {
  id: number;
  nombre: string;
  descripcion?: string | null;
  orden?: number;
  activa?: boolean;
  created_at?: string;
  updated_at?: string;
};

const normalizeList = <T,>(payload: unknown): T[] => {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (payload && typeof payload === 'object') {
    const data = (payload as { data?: unknown[] }).data;
    if (Array.isArray(data)) {
      return data as T[];
    }
  }

  return [];
};

export const fetchCategorias = async (): Promise<CategoriaApi[]> => {
  const token = getStoredAuthToken();
  const payload = await apiRequest<unknown>('/api/catalogos/categorias?per_page=100&activa=1', { token });
  return normalizeList<CategoriaApi>(payload);
};

export const createCategoria = async (data: Partial<CategoriaApi>): Promise<CategoriaApi> => {
  const token = getStoredAuthToken();
  return apiRequest<CategoriaApi>('/api/catalogos/categorias', {
    token,
    method: 'POST',
    body: data,
  });
};

export type UnidadMedidaApi = {
  id: number;
  nombre: string;
  simbolo?: string;
};

export const fetchUnidades = async (): Promise<UnidadMedidaApi[]> => {
  const token = getStoredAuthToken();
  const payload = await apiRequest<unknown>('/api/catalogos/unidades-medida?per_page=100', { token });
  return normalizeList<UnidadMedidaApi>(payload);
};

export const createUnidad = async (data: Partial<UnidadMedidaApi>): Promise<UnidadMedidaApi> => {
  const token = getStoredAuthToken();
  return apiRequest<UnidadMedidaApi>('/api/catalogos/unidades-medida', {
    token,
    method: 'POST',
    body: data,
  });
};

export type PeriodicidadApi = {
  id: number;
  nombre: string;
  dias?: number;
};

export const fetchPeriodicidades = async (): Promise<PeriodicidadApi[]> => {
  const token = getStoredAuthToken();
  const payload = await apiRequest<unknown>('/api/catalogos/periodicidades?per_page=100', { token });
  return normalizeList<PeriodicidadApi>(payload);
};

export const createPeriodicidad = async (data: Partial<PeriodicidadApi>): Promise<PeriodicidadApi> => {
  const token = getStoredAuthToken();
  return apiRequest<PeriodicidadApi>('/api/catalogos/periodicidades', {
    token,
    method: 'POST',
    body: data,
  });
};
